import { render } from "./LaitLogo.vue?vue&type=template&id=5f60e544&ts=true"
import script from "./LaitLogo.vue?vue&type=script&lang=ts"
export * from "./LaitLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__